import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchAdminSettings,
  updateFeatureFlag,
  updateMaintenanceMode,
  type AdminSettings,
  type FeatureFlag,
} from '../api/adminSettings';

export function useAdminSettings() {
  return useQuery<AdminSettings>({
    queryKey: ['admin-settings'],
    queryFn: fetchAdminSettings,
    staleTime: 1000 * 60,
  });
}

export function useMaintenanceMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ maintenanceMode, maintenanceMessage }: { maintenanceMode: boolean; maintenanceMessage?: string }) =>
      updateMaintenanceMode(maintenanceMode, maintenanceMessage),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-settings'] });
    },
  });
}

export function useFeatureFlagMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (flag: FeatureFlag) => updateFeatureFlag(flag),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-settings'] });
    },
  });
}
